// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__St9Nw","title":"styles_title__TPL3h","updatedDate":"styles_updatedDate__QbopU","infoTitle":"styles_infoTitle__CzY9w"};